import React, { useState } from "react";
import { Col, Card, ListGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { PricingPanelCss } from "./PricingPanelCss";
import { PricePanel as PricingPanelI } from "../../types/interfaces/PricingPanel";
import "./PricingPanel.css";
import { Link } from "react-router-dom";
import { useProductCheckout } from "modules/payment/hooks/useProductCheckout";
import { useAuth } from "modules/auth/hooks";

const PricingPanel = (panel: PricingPanelI) => {
  const { performCheckout, error } = useProductCheckout();
  const { user, login } = useAuth();

  const doCheckOut = (uuid: string) => {
    panel.setLoading(true)
    performCheckout(uuid)
  }

  return (
    <Col key={panel.price} className="mb-30" style={{ marginBottom: "30px" }}>
      <Card
        className={`pricing-panel ${
          panel.position === 1 ? "active" : ""
        } modify-pricing-panel  text-center`}
        style={PricingPanelCss.pricingPanel}
      >
        <Card.Body>
          <div className="pricing-heading" style={PricingPanelCss.panelHeading}>
            <h2>
              {`${panel.price}`}
              <span> / {panel.type.replaceAll("_", "-")}</span>
            </h2>
            <h3>{panel.category.replaceAll("_", " ")}</h3>
          </div>
          <div className="pricing-body">
            <p>
              {panel?.duration} <br /> <br />
              {panel?.description}
            </p>
            <ListGroup variant="flush">
              {panel?.features?.map((feature, featureIndex) => (
                <ListGroup.Item
                  style={PricingPanelCss.features}
                  key={featureIndex}
                >
                  {feature}
                </ListGroup.Item>
              ))}
            </ListGroup>
          </div>
        </Card.Body>
        <div className="pricing-footer" style={PricingPanelCss.pricingFooter}>
          <span
            className="plan-btn btn btn-danger"
            style={PricingPanelCss.planBtn}
            onClick={() => user ? doCheckOut(panel.uuid) : login()}
          >
            Buy Now
          </span>
        </div>
      </Card>
    </Col>
  );
};

export default PricingPanel;
